import { skipToken } from "@reduxjs/toolkit/query";
import { useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { Logo } from "../../../../../App/assets/img";
import {
  useOrderGetQuery,
  usePrintOrderMutation,
} from "../../../../../Features/order/order-slice";
import SimpleButton from "../../../../../shared/components/Button/Button";
import CustomModal from "../../../../../shared/components/CustomModal";
import DatePickerComponent from "../../../../../shared/components/DatePicker/DatePicker";
import TextArea from "../../../../../shared/components/TextArea";
import TextBox from "../../../../../shared/components/TextBox";
import {
  ACTION_LABEL,
  BUTTON_LABEL,
  LABELS,
  toastError,
  toastSuccess,
} from "../../../../../shared/constants";
import {
  bottomMeasurement,
  DATE_FORMAT,
  topMeasurement,
} from "../../../../../shared/constants/resource";
import { getMeasurementIds } from "../../../../../shared/helperFunc/getMeasurementByIds";
import ConfirmPrint from "../ConfirmPrint";
import Barcode from "react-barcode";
import moment from "moment";

const PrintOrder = (props: any) => {
  const {
    id,
    data,
    currentRow,
    setShowPrintOrder,
    handleClosePrintOrder,
    // refetchOrderApi,
  } = props;

  const contentRef = useRef<HTMLDivElement>(null);
  const [printOrderData, setPrintOrderData] = useState({
    itemCode: data.itemJson?.itemCode,
    srNo: currentRow.documentNo,
    // cus: currentRow.firstName + " " + currentRow.lastName,
    storeName: currentRow.store?.shortCode,
    designNo: data.itemJson?.designNo,
    fabricCode: data.itemJson?.fabricCode,
    color: data.itemJson?.color,
    date: currentRow.deliveryDate,
    remark: currentRow.remarks,
    price: data.itemJson?.price,
    soNo: currentRow.ordCode,
    createdAt: data.itemJson?.createdAt,
    qty: data.itemJson?.qty,
  });

  const [errors, setErrors]: any = useState({});
  const [showConfirmPrintModal, setShowConfirmPrintModal] = useState(false);

  let orderId = currentRow._id;

  const { refetch: getOrderRefetch } = useOrderGetQuery(orderId || skipToken, {
    refetchOnMountOrArgChange: true,
  });

  const [printOrder] = usePrintOrderMutation();

  const printData = useReactToPrint({ contentRef });

  const printOrderFlow = async (data: any) => {
    setShowConfirmPrintModal(!showConfirmPrintModal);
    printData();
    getOrderRefetch();
    // refetchOrderApi();
    setShowPrintOrder(false);
  };

  const handleOnChange = (e: any) => {
    setPrintOrderData({ ...printOrderData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const handleDateChange = (value: any) => {
    setPrintOrderData({ ...printOrderData, date: value });
    setErrors({ ...errors, date: "" });
  };

  const handleConfirm = () => {
    setShowConfirmPrintModal(!showConfirmPrintModal);
  };

  const handlePrint = async () => {
    let measurement: any = {};
    if (data?.top?.length) {
      measurement.top = getMeasurementIds(
        data.top.map((item: any) => item.type),
        topMeasurement
      );
    }

    if (data?.bottom?.length) {
      measurement.bottom = getMeasurementIds(
        data.bottom.map((item: any) => item.type),
        bottomMeasurement
      );
    }

    if (data?.custom) {
      measurement.custom = Object.keys(data?.custom).filter(
        (item) => data?.custom[item]
      );
    }

    if (data?.accessories) {
      measurement.accessories = Object.keys(data?.accessories).filter(
        (item) => data?.accessories[item]
      );
    }

    let payload: any = {
      itemCode: data?.itemJson.itemCode,
    };

    if (Object.keys(measurement).length > 0) {
      payload.measurement = measurement;
    }
    const printOrderResponse = await printOrder({
      id: id,
      data: payload,
    })
      .unwrap()
      .catch((err: any) => {
        toastError(err.data?.errors[0]?.msg);
      });
    if (printOrderResponse && printOrderResponse?.status) {
      printOrderFlow(printOrderResponse);
    }
  };

  const closeConfirmPrintModal = () => {
    setShowConfirmPrintModal(!showConfirmPrintModal);
  };

  const confirmPrintModal = (handlePrint: any, closeModal: any) => {
    return [
      {
        text: BUTTON_LABEL.YES,
        action: handlePrint,
        className: "btn theme-btn theme-btn-sm w-auto",
      },
      {
        text: BUTTON_LABEL.NO,
        action: closeModal,
        className: "btn theme-btn theme-btn-sm btn-inverse w-auto",
      },
    ];
  };

  const confirmPrintModalButton = confirmPrintModal(
    handlePrint,
    closeConfirmPrintModal
  );

  const measurementStandardBlock = (item: any) => {
    return (
      <div className="value">
        <label htmlFor="">{item?.title}</label>
        <span className="label-box">{item?.value}</span>
      </div>
    );
  };

  const customMeasurementBlock = (title: any, value: any) => {
    if (value) {
      return (
        <div className="item-card mb-2">
          <div className="item-header ">
            <span>{title}</span>
          </div>
          <div className="item-body">
            <div className="populate-values">
              <div className="value">
                <span className="label-box">{value}</span>
              </div>
            </div>
          </div>
        </div>
      );
    }
  };

  const dateConvertFiveDaysEarly = (date: any) => {
    if (date) {
      const pastDate = new Date(date);
      pastDate.setDate(pastDate.getDate() - 5);
      return pastDate;
    }
  };

  return (
    <>
      <div>
        <div ref={contentRef} className="print-page">
          <div className="pritable-area pt-4">
            <div className="row">
              <div className="col-md-2">
                <img src={Logo} alt="lock" width={180} />
              </div>
              <div className="col-md-10 text-center">
                <h3>{LABELS.PRINT_ORDER_TITLE_TEXT}</h3>
                <p>
                  {LABELS.PRINT_ORDER_HOUSE_ADDRESS_TEXT} <br />
                  {LABELS.PRINT_ORDER_ADDRESS_TEXT} <br />
                  {LABELS.PRINT_ORDER_PHONE_TEXT}
                </p>
              </div>
            </div>
            <div className="inner">
              <div className="row mb-3">
                <div className="col-12 col-md-5">
                  <div
                    className={`d-flex align-items-center has-ribbon-text position-relative ${data.itemJson?.isCustom && "input-with-ribbon"}`}
                  >
                    {data.itemJson?.isCustom && (
                      <div className="ribbon">Custom</div>
                    )}
                    <TextBox
                      name={ACTION_LABEL.SR_NO}
                      placeholder={LABELS.SR_NO_TEXT}
                      id={LABELS.SR_NO_TEXT}
                      label={LABELS.SR_NO_TEXT}
                      onChange={handleOnChange}
                      value={printOrderData.srNo}
                      errorMessage={errors.srNo || null}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-5 ms-auto">
                  <div className="d-flex align-items-center">
                    <DatePickerComponent
                      label={LABELS.DISPATCH_DATE_TEXT}
                      value={dateConvertFiveDaysEarly(printOrderData.date)}
                      onChange={handleDateChange}
                      placeholder={"DD/MM/YYYY"}
                      format="dd/MM/yyyy"
                      placement="bottom-start"
                      errorMessage={errors.date || null}
                    />
                  </div>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-12 col-md-5">
                  <div className="d-flex align-items-center">
                    <TextBox
                      name={ACTION_LABEL.DESIGN_NO}
                      placeholder={LABELS.DESIGN_NO_TEXT}
                      id={LABELS.DESIGN_NO_TEXT}
                      label={LABELS.DESIGN_NO_TEXT}
                      onChange={handleOnChange}
                      value={printOrderData.designNo}
                      errorMessage={errors.designNo || null}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-5 ms-auto">
                  <div className="d-flex align-items-center">
                    <TextBox
                      name={ACTION_LABEL.FABRIC_CODE}
                      placeholder={LABELS.FABRIC_CODE_TEXT}
                      id={LABELS.FABRIC_CODE_TEXT}
                      label={LABELS.FABRIC_CODE_TEXT}
                      onChange={handleOnChange}
                      value={printOrderData.fabricCode}
                      errorMessage={errors.fabricCode || null}
                    />
                  </div>
                </div>
              </div>
              <div className="row mb-3">
                <div className="col-12 col-md-5">
                  <div className="d-flex align-items-center">
                    <TextBox
                      name={ACTION_LABEL.CREATED_AT}
                      placeholder={LABELS.ORDER_DATE_TEXT}
                      id={LABELS.ORDER_DATE_TEXT}
                      label={LABELS.ORDER_DATE_TEXT}
                      value={moment(printOrderData.createdAt).format(
                        DATE_FORMAT.STANDARD
                      )}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-5 ms-auto">
                  <div className="d-flex align-items-center">
                    <TextBox
                      name={ACTION_LABEL.QTY}
                      placeholder={LABELS.QTY_TEXT}
                      id={LABELS.QTY_TEXT}
                      label={LABELS.QTY_TEXT}
                      value={printOrderData.qty}
                    />
                  </div>
                </div>
              </div>

              <div className="row mb-3">
                <div className="col-12 col-md-5 ">
                  <div className="d-flex align-items-center">
                    <TextBox
                      name={ACTION_LABEL.COLOR}
                      placeholder={LABELS.COLOR_TEXT}
                      id={LABELS.COLOR_TEXT}
                      label={LABELS.COLOR_TEXT}
                      onChange={handleOnChange}
                      value={printOrderData.color}
                      errorMessage={errors.color || null}
                    />
                  </div>
                </div>
              </div>
              <div className="row mb-3">
                {data.isPrintAll && (
                  <div className="col-12 col-md-5">
                    <div className="d-flex align-items-center">
                      <TextBox
                        name={ACTION_LABEL.PRICE}
                        placeholder={LABELS.MRP_TEXT}
                        id={LABELS.MRP_TEXT}
                        label={LABELS.MRP_TEXT}
                        value={printOrderData.price}
                      />
                    </div>
                  </div>
                )}
                {currentRow.isConfirmed && (
                  <div className="col-12 col-md-5 ms-auto">
                    <div className="d-flex align-items-center">
                      <TextBox
                        name={ACTION_LABEL.SO_NO}
                        placeholder={LABELS.SO_NO_TEXT}
                        id={LABELS.SO_NO_TEXT}
                        label={LABELS.SO_NO_TEXT}
                        value={printOrderData.soNo}
                      />
                    </div>
                  </div>
                )}
              </div>
              <div className="row mb-3">
                <div className="col-12">
                  <div className="d-flex align-items-center">
                    <TextBox
                      placeholder={LABELS.STORE_CODE_TEXT}
                      id={LABELS.STORE_CODE_TEXT}
                      label={LABELS.STORE_CODE_TEXT}
                      value={printOrderData.storeName}
                      errorMessage={errors.storeName || null}
                    />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  {Array.isArray(data?.top) &&
                    data.top.map((data: any) => {
                      const remarks = data.remarks;
                      return (
                        <div className="item-card mb-2 page-break">
                          <div className="item-header">
                            <span>{data.type}</span>
                          </div>
                          <div className="item-body">
                            <div className="populate-values">
                              {Array.isArray(data?.data) &&
                                data.data.map((el: any) => {
                                  return measurementStandardBlock(el);
                                })}
                            </div>
                            {remarks && (
                              <div className="row">
                                <div className="col-12">
                                  <div className="form-group">
                                    <TextArea
                                      name={ACTION_LABEL.REMARKS}
                                      id={LABELS.REMARKS_TEXT}
                                      label={LABELS.REMARKS_TEXT}
                                      value={remarks}
                                      maxLength={250}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}

                  {Array.isArray(data?.bottom) &&
                    data.bottom.map((data: any) => {
                      const remarks = data.remarks;
                      return (
                        <div className="item-card mb-2">
                          <div className="item-header">
                            <span>{data.type}</span>
                          </div>
                          <div className="item-body">
                            <div className="populate-values">
                              {Array.isArray(data?.data) &&
                                data.data.map((el: any) => {
                                  return measurementStandardBlock(el);
                                })}
                            </div>
                            {remarks && (
                              <div className="row">
                                <div className="col-12">
                                  <div className="form-group">
                                    <TextArea
                                      name={ACTION_LABEL.REMARKS}
                                      id={LABELS.REMARKS_TEXT}
                                      label={LABELS.REMARKS_TEXT}
                                      value={remarks}
                                      maxLength={250}
                                    />
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      );
                    })}

                  {data?.custom &&
                    typeof data?.custom === "object" &&
                    Object.keys(data?.custom).map((ele: any, index: any) => {
                      return customMeasurementBlock(ele, data?.custom[ele]);
                    })}

                  {data?.accessories &&
                    typeof data?.accessories === "object" &&
                    Object.keys(data?.accessories).map(
                      (ele: any, index: any) => {
                        return customMeasurementBlock(
                          ele,
                          data?.accessories[ele]
                        );
                      }
                    )}
                </div>
              </div>
              {currentRow?.comments?.list?.length > 0 && (
                <div
                  className="row mb-3 pt-3 mt-3 comment-print-wrapper"
                  style={{
                    marginTop: "20px",
                    paddingTop: "15px",
                    pageBreakInside: "auto",
                    breakInside: "auto",
                  }}
                >
                  <div className="col-12">
                    <h6
                      className="section-title pt-2 mb-3"
                      style={{
                        marginTop: "16px",
                        marginBottom: "14px",
                        paddingTop: "10px",
                      }}
                    >
                      {LABELS.COMMENTS_TEXT}
                    </h6>
                    {currentRow.comments.list.map(
                      (comment: any, commentIndex: number) => (
                        <div
                          key={comment._id || commentIndex}
                          className="comment-print-item-wrapper"
                          style={{
                            paddingTop: "20px",
                            paddingBottom: "4px",
                            pageBreakInside: "avoid",
                            breakInside: "avoid",
                          }}
                        >
                          <div
                            className="comment-print-item"
                            style={{
                              border: comment.isImportant
                                ? "1px solid #f0ad4e"
                                : "1px solid #e3e3e3",
                              borderRadius: "6px",
                              padding: "10px 14px",
                              marginTop: "0",
                              marginBottom: "0",
                              backgroundColor: comment.isImportant
                                ? "#fff9f0"
                                : "#ffffff",
                              pageBreakInside: "avoid",
                              breakInside: "avoid",
                            }}
                          >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              marginBottom: "4px",
                            }}
                          >
                            <strong style={{ fontSize: "12px" }}>
                              {comment.authorName || ""}
                              {comment.userRole
                                ? ` (${
                                    comment.userRole === "back_office"
                                      ? LABELS.ROLE_BACK_OFFICE_TEXT
                                      : LABELS.ROLE_STORE_TEXT
                                  })`
                                : ""}
                            </strong>
                            {comment.isImportant && (
                              <span
                                style={{
                                  fontSize: "10px",
                                  color: "#b06a00",
                                  fontWeight: 600,
                                }}
                              >
                                {LABELS.IMPORTANT_TEXT}
                              </span>
                            )}
                          </div>
                          {comment.commentText && (
                            <div
                              style={{
                                fontSize: "12px",
                                whiteSpace: "pre-wrap",
                                wordBreak: "break-word",
                                overflowWrap: "anywhere",
                              }}
                            >
                              {comment.commentText}
                            </div>
                          )}
                          {comment.images &&
                            comment.images.filter((img: any) => !img.isPurged).length > 0 && (() => {
                              const activeImages = comment.images.filter((img: any) => !img.isPurged);
                              const isFullRow = activeImages.length >= 4;
                              return (
                                <div
                                  className="d-flex justify-content-start align-items-start pt-2"
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    flexWrap: "nowrap",
                                    justifyContent: "flex-start",
                                    alignItems: "flex-start",
                                    gap: isFullRow ? "12px" : "18px",
                                    width: "100%",
                                    marginTop: "10px",
                                    marginBottom: "10px",
                                    pageBreakInside: "avoid",
                                    breakInside: "avoid",
                                  }}
                                >
                                  {activeImages.map((img: any, imgIdx: number) => {
                                    const rawUrl =
                                      img.imageUrl || img.thumbnailUrl || "";
                                    const imgUrl = rawUrl.startsWith("http")
                                      ? rawUrl
                                      : `${
                                          process.env.REACT_APP_BACKEND_URL || ""
                                        }${rawUrl}`;
                                    return (
                                      <div
                                        key={img._id || imgIdx}
                                        className="text-center mb-2"
                                        style={{
                                          pageBreakInside: "avoid",
                                          breakInside: "avoid",
                                          flex: isFullRow ? "1 1 0px" : "0 0 140px",
                                          width: isFullRow ? "auto" : "140px",
                                          maxWidth: isFullRow
                                            ? `${Math.floor(100 / activeImages.length)}%`
                                            : "140px",
                                          minWidth: 0,
                                        }}
                                      >
                                        <img
                                          src={imgUrl}
                                          alt={
                                            img.fileName ||
                                            `Attachment ${imgIdx + 1}`
                                          }
                                          className="comment-print-image"
                                          style={{
                                            height: "170px",
                                            maxHeight: "170px",
                                            width: isFullRow ? "100%" : "140px",
                                            maxWidth: "100%",
                                            objectFit: "contain",
                                            display: "block",
                                            margin: "0 auto",
                                            borderRadius: "6px",
                                            border: "1px solid #e0e0e0",
                                            backgroundColor: "#fafafa",
                                          }}
                                          onError={(e) => {
                                            const parent =
                                              e.currentTarget.parentElement;
                                            if (parent) {
                                              parent.style.display = "none";
                                            }
                                          }}
                                        />
                                        <p
                                          className="mb-0 mt-1"
                                          style={{
                                            fontSize: "11px",
                                            fontWeight: 500,
                                            maxWidth: "100%",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                            whiteSpace: "nowrap",
                                            textAlign: "center",
                                          }}
                                          title={img.fileName || `Image ${imgIdx + 1}`}
                                        >
                                          {img.fileName ||
                                            `Image ${imgIdx + 1}`}
                                        </p>
                                      </div>
                                    );
                                  })}
                                </div>
                              );
                            })()}
                          <div
                            style={{
                              fontSize: "10px",
                              color: "#888",
                              marginTop: "4px",
                            }}
                          >
                            {comment.createdAt
                              ? moment(comment.createdAt).format(
                                  DATE_FORMAT.DATE_TIME
                                )
                              : ""}
                          </div>
                        </div>
                      </div>
                      )
                    )}
                  </div>
                </div>
              )}
              <div className="form-group pt-4" style={{ pageBreakInside: "avoid", breakInside: "avoid", paddingTop: "25px" }}>
                <TextArea
                  name={ACTION_LABEL.REMARK}
                  placeholder={LABELS.REMARKS_TEXT}
                  id={LABELS.REMARKS_TEXT}
                  label={LABELS.REMARKS_TEXT}
                  onChange={handleOnChange}
                  value={printOrderData.remark}
                  errorMessage={errors.remark || null}
                  required
                />
              </div>
              <div className="form-group text-center my-2 py-1" style={{ pageBreakInside: "avoid", breakInside: "avoid" }}>
                <Barcode value={printOrderData.itemCode} height={55} margin={5} />
              </div>
              {currentRow?.referenceImages?.filter((img: any) => !img.isPurged)?.length > 0 && (() => {
                const activeImages = currentRow.referenceImages.filter((img: any) => !img.isPurged);
                const isFullRow = activeImages.length >= 4;
                return (
                  <div className="row mb-3 pt-2">
                    <div className="col-12">
                      <h6 className="section-title pt-2">{LABELS.REFERENCE_IMAGES_TEXT}</h6>
                      <div
                        className="d-flex justify-content-start align-items-start pt-2"
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          flexWrap: "nowrap",
                          justifyContent: "flex-start",
                          alignItems: "flex-start",
                          gap: isFullRow ? "12px" : "18px",
                          width: "100%",
                          pageBreakInside: "avoid",
                          breakInside: "avoid",
                        }}
                      >
                        {activeImages.map((img: any, imgIndex: number) => {
                          const rawUrl = img.imageUrl || img.thumbnailUrl || "";
                          const imgUrl = rawUrl.startsWith("http")
                            ? rawUrl
                            : `${process.env.REACT_APP_BACKEND_URL || ""}${rawUrl}`;
                          return (
                            <div
                              key={img._id || imgIndex}
                              className="text-center mb-2"
                              style={{
                                pageBreakInside: "avoid",
                                breakInside: "avoid",
                                flex: isFullRow ? "1 1 0px" : "0 0 140px",
                                width: isFullRow ? "auto" : "140px",
                                maxWidth: isFullRow
                                  ? `${Math.floor(100 / activeImages.length)}%`
                                  : "140px",
                                minWidth: 0,
                              }}
                            >
                              <img
                                src={imgUrl}
                                alt={img.fileName || `Ref ${imgIndex + 1}`}
                                style={{
                                  height: "170px",
                                  maxHeight: "170px",
                                  width: isFullRow ? "100%" : "140px",
                                  maxWidth: "100%",
                                  objectFit: "contain",
                                  display: "block",
                                  margin: "0 auto",
                                  borderRadius: "6px",
                                  border: "1px solid #e0e0e0",
                                  backgroundColor: "#fafafa",
                                }}
                                onError={(e) => {
                                  const parent = e.currentTarget.parentElement;
                                  if (parent) {
                                    parent.style.display = "none";
                                  }
                                }}
                              />
                              <p
                                className="mb-0 mt-1"
                                style={{
                                  fontSize: "11px",
                                  fontWeight: 500,
                                  maxWidth: "100%",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                  textAlign: "center",
                                }}
                                title={img.fileName || `Image ${imgIndex + 1}`}
                              >
                                {img.fileName || `Image ${imgIndex + 1}`}
                              </p>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                );
              })()}
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center d-print-none">
          <SimpleButton
            className="btn theme-btn theme-btn-sm me-2"
            onClick={handleConfirm}
            text={BUTTON_LABEL.PRINT}
          />
          <SimpleButton
            className="btn theme-btn theme-btn-sm me-2"
            onClick={handleClosePrintOrder}
            text={BUTTON_LABEL.CLOSE}
          />
        </div>
      </div>

      <CustomModal
        show={showConfirmPrintModal}
        close={closeConfirmPrintModal}
        message={""}
        size="md"
        modalTitle={LABELS.PRINT_CONFIRMATION_TEXT}
        modalButton={confirmPrintModalButton}
        fullscreen={undefined}
        className={""}
        centerClass={""}
        modalTitleIcon={""}
      >
        <ConfirmPrint itemPrintData={data} />
      </CustomModal>
    </>
  );
};

export default PrintOrder;
